/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentSocialUploadsUploadByIdQueryResponse, GetFragmentSocialUploadsUploadByIdPathParams } from "../models/GetFragmentSocialUploadsUploadById";

export function getGetFragmentSocialUploadsUploadByIdUrl(uploadId: GetFragmentSocialUploadsUploadByIdPathParams["uploadId"]) {
  const res = { method: 'GET', url: `/fragment-social-uploads/${uploadId}` as const }
  return res
}

/**
 * @summary Get a single social upload by id
 * {@link /fragment-social-uploads/:uploadId}
 */
export async function getFragmentSocialUploadsUploadById(uploadId: GetFragmentSocialUploadsUploadByIdPathParams["uploadId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentSocialUploadsUploadByIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetFragmentSocialUploadsUploadByIdUrl(uploadId).url.toString(), ... requestConfig })
  return res.data
}